@if (label) {
    <div role="presentation" class="cmdk-group-label">
      <ng-container *dynamicView="label"></ng-container>
    </div>
  }
<div class="cmdk-group-content" role="group" [attr.aria-label]="ariaLabel">
  <ng-content></ng-content>
</div>
